import React from "react";
import { GlobalContext } from "../../../../../../utils/globalprovider";
class SubtitleCloseGap extends React.Component 
{
    static contextType = GlobalContext;
    constructor(props) {
        super(props);

        this.state = {
            enabled: props.enabled ?? false,
            method: props.method ?? 0,
            value: props.value ?? 0
        };
    }

    notifyChange = () => {
        if (this.props.onChange) {
            this.props.onChange({
                enabled: this.state.enabled,
                method: this.state.method,
                value: this.state.value
            });
        }
    }

    handleEnabled = (e) => {
        this.setState(
            { enabled: e.target.checked },
            this.notifyChange
        );
    }

    handleMethod = (e) => {
        this.setState(
            { method: parseInt(e.target.value) },
            this.notifyChange
        );
    }

    handleValue = (e) => {
        let value = parseInt(e.target.value);

        if (isNaN(value))
            value = 0;

        value = Math.max(0, Math.min(25, value));

        this.setState(
            { value },
            this.notifyChange
        );
    }

    render() {

        const styleContainer = {
            width: "98%",
            backgroundColor: "#000",
            color: "white",
            fontSize: "12px",
            boxSizing: "border-box",
            padding: "10px",
            border: "1px solid #555",
            borderRadius: "6px",
            marginBottom: "8px",
            textAlign:"left"
        };

        const styleRow = {
            display: "flex",
            alignItems: "center",
            marginTop: "8px"
        };

        const styleLabel = {
            width: "70px",
            flexShrink: 0
        };

        const styleSelect = {
            flex: 1,
            backgroundColor: "#222",
            color: "white",
            border: "1px solid #666",
            borderRadius: "4px",
            fontSize: "12px",
            padding: "2px 4px"
        };

        const styleSpin = {
            width: "60px",
            backgroundColor: "#222",
            color: "white",
            border: "1px solid #666",
            borderRadius: "4px",
            fontSize: "12px",
            padding: "2px 4px"
        };

        return (
            <div style={styleContainer}>

                <div style={{fontWeight:"bold", textAlign:"center"}}>
                    {this.context.language=="fr"?"Sous-titres trop proches":"Subtitles too close together"}
                </div>

                <div style={{marginTop:"8px"}}>
                    <label>
                        <input
                            type="checkbox"
                            checked={this.state.enabled}
                            onChange={this.handleEnabled}
                            style={{marginRight:"6px"}}
                        />
                        {this.context.language=="fr"?"Corriger l'intervalle entre sous-titre":"Correct the subtitle interval"}
                    </label>
                </div>

                <div style={styleRow}>
                    <div style={styleLabel}>
                        {this.context.language=="fr"?"Méthode":"Method"}
                    </div>

                    <select
                        style={styleSelect}
                        value={this.state.method}
                        onChange={this.handleMethod}
                        disabled={!this.state.enabled}
                    >
                        <option value={0}>
                            {this.context.language=="fr"?"Augmenter le time code in":"Increase the time code in"}
                        </option>
                        <option value={1}>
                            {this.context.language=="fr"?"Diminuer le time code out":"Decrease the out timecode"}
                        </option>
                        <option value={2}>
                            {this.context.language=="fr"?"Augmenter le time code in et diminuer le out":"Increase the time code in and decrease the time code out"}
                        </option>
                    </select>
                </div>

                <div style={styleRow}>
                    <div style={styleLabel}>
                        {this.context.language=="fr"?"Valeur":"Value"}
                    </div>

                    <input
                        type="number"
                        min={0}
                        max={25}
                        value={this.state.value}
                        onChange={this.handleValue}
                        style={styleSpin}
                        disabled={!this.state.enabled}
                    />
                </div>

            </div>
        );
    }
}

export default SubtitleCloseGap;